'use client';
'use strict';

var _tslib = require('../../../../_virtual/_tslib.js');
var jsxRuntime = require('react/jsx-runtime');
var tailwindMerge = require('tailwind-merge');
var Typography = require('../../../Base/Typography/Typography.js');
var Box = require('../../../Base/Layouts/Box/Box.js');
require('../../../Base/Layouts/FullBleed/FullBleed.js');
var Radio = require('../../Radio/Radio.js');

const RadioListItemContainer = (_a)=>{
    var { children, disabled, className, hasDescription } = _a, rest = _tslib.__rest(_a, [
        "children",
        "disabled",
        "className",
        "hasDescription"
    ]);
    return jsxRuntime.jsx("label", Object.assign({
        className: tailwindMerge.twMerge('grid h-min grid-cols-radio-list-item-container grid-rows-radio-list-item-container gap-x-3 grid-areas-radio-list-item-container', disabled ? 'cursor-not-allowed' : 'cursor-pointer', hasDescription ? 'gap-y-0.5' : 'gap-y-0', className)
    }, rest, {
        children: children
    }));
};
const RadioListItem = ({ name, value, label, description, isSelected, isDisabled = false, isError = false, className, RadioClassName, onChange })=>{
    return jsxRuntime.jsxs(RadioListItemContainer, {
        "data-testid": "design-system-radioList--item",
        disabled: isDisabled,
        hasDescription: !!description,
        className: tailwindMerge.twMerge('group', className),
        children: [
            jsxRuntime.jsx(Box, {
                className: "flex cursor-pointer pt-1 grid-in-radio",
                children: jsxRuntime.jsx(Radio, {
                    name: name,
                    value: value,
                    isSelected: isSelected,
                    isError: isError,
                    isDisabled: isDisabled,
                    onChange: onChange,
                    className: RadioClassName
                })
            }),
            jsxRuntime.jsx(Box, {
                className: "flex w-full items-center grid-in-label",
                children: jsxRuntime.jsx(Typography, {
                    variant: "body1",
                    className: tailwindMerge.twMerge('w-full whitespace-normal break-words', isDisabled ? 'text-w-gray-300' : 'text-w-gray-900'),
                    "data-testid": "design-system-radioList--item-label",
                    children: label
                })
            }),
            description && jsxRuntime.jsx(Box, {
                className: "flex items-center grid-in-description",
                children: jsxRuntime.jsx(Typography, {
                    variant: "body2",
                    className: isDisabled ? 'text-w-gray-300' : 'text-w-gray-600',
                    "data-testid": "design-system-radioList--item-description",
                    children: description
                })
            })
        ]
    });
};

module.exports = RadioListItem;
